import { render, staticRenderFns } from "./SectionText.vue?vue&type=template&id=50b0b7d4&scoped=true&"
import script from "./SectionText.vue?vue&type=script&lang=js&"
export * from "./SectionText.vue?vue&type=script&lang=js&"
import style0 from "./SectionText.vue?vue&type=style&index=0&id=50b0b7d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b0b7d4",
  null
  
)

export default component.exports